import { IPDisponibles } from '@/shared/interfaces';
import { Box, lighten, LinearProgress, styled, Typography } from '@mui/material';
import React from 'react';

interface Props {
  color?: 'primary' | 'secondary';
  hex?: string;
  value?: number;

  ipDisponibles?: IPDisponibles[];
  total_ips?: number
  total_ips_used?: number
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  width: '100%',
  borderRadius: '10px',
  backgroundColor:
    theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800],
}));

const WhiteTextTypography = styled(Typography)({
  color: '#FFFFFF',
  fontWeight: 'bold',
});

const ProgressBarIPVGroups: React.FC<Props> = ({
  color,
  hex,
  ipDisponibles,
  total_ips,
  total_ips_used,
}) => {
  console.log({total_ips, total_ips_used})
  
  let internalColor: string;
  const ipDisponibleArr: IPDisponibles[] = ipDisponibles || [];
  // const availableIps = +ipDisponibleArr.filter(ip => ip?.estado).length || 0;
  const inUseIps = ipDisponibles?.length!>0? 
    (+ipDisponibleArr.filter(ip => !ip?.estado).length || 0)
    : total_ips_used;

  const totalIps = ipDisponibles?.length!>0?
    +ipDisponibleArr.length
    : total_ips;
    
  let value: number | string = ((inUseIps||1) / (totalIps||1)) * 100;
  if (isNaN(value)) value = 0;
  value = Math.round(value).toFixed(2);

  if (hex && /^#[0-9A-F]{6}$/i.test(hex)) {
    internalColor = hex;
  } else {
    internalColor = '#3f51b5';
  }

  if (+value < 0 || +value > 100) {
    console.error(value);
    throw new Error(
      'Invalid value prop -- please use a number between 0 and 100.'
    );
  }

  return (
    <Box position="relative" display="inline-flex" style={{ width: '100%' }}>
      <BorderLinearProgress
        color={hex ? undefined : color}
        variant="determinate"
        value={+value}
        sx={{
          backgroundColor: hex ? lighten(internalColor, 0.5) : undefined,
          '& .MuiLinearProgress-bar': {
            borderRadius: 20,
            backgroundColor: hex ? internalColor : undefined,
          },
        }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <WhiteTextTypography variant="body2">{`${value}% (${
          inUseIps || 0
        } de ${totalIps})`}</WhiteTextTypography>
      </Box>
    </Box>
  );
};

export default ProgressBarIPVGroups;
